import { useState, createContext, useContext} from 'react';
import { API } from 'aws-amplify';
import { FilterDate, Filters } from '../models/FilterPreferenceInterface';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';

const FilterContext = createContext({
    defaultSearchState: true,
    filterPreferenceData: {} as Filters,
    loading: true,
    getFilterPreferenceData: (date: FilterDate) => {},
    saveFilterPreferenceData: (filterPreferences: Filters, date: FilterDate) => {},
    setSearchState: (defaultSearchState: boolean) => {},
});

export const FilterPreferenceProvider = (props) => {
    
    const [filterPreferenceData, setFilterPreferenceData] = useState({} as Filters); 
    const [loading, setLoading] = useState(true);
    const [defaultSearchState, setDefaultSearchState] = useState(true);
    const {setErrorCode} = useApiError();

    const getFilterPreferenceData = async(date: FilterDate) => {
        try {
            setLoading(true); 
            const filterPreference = await API.get('crewlife', `/filterpreference/retrieve/pairingreport/default?month=${date.month}&year=${date.year}`, {});
            filterPreference.filters.selectedDateFilter.dates.forEach((date,index) => {
                filterPreference.filters.selectedDateFilter.dates[index] = new Date(date);
            })
            setFilterPreferenceData(filterPreference.filters);
            setLoading(false);
        } catch(e: any) { 
            if (e.response?.status) setErrorCode(e.response?.status);
            else setErrorCode(error.DEFAULT); 
        } finally {
            setLoading(false);
        }
    }

    const saveFilterPreferenceData = async(filterData: Filters, date: FilterDate) => {
        try {
            setLoading(true);
            const requestObject = {
                body: {
                    screenName: 'pairingreport', 
                    presetName: 'default', 
                    month: date.month,
                    year: date.year,
                    filters: {
                        ...filterData
                    }
                }
            }
            await API.post('crewlife', '/filterpreference/save', requestObject);
            setFilterPreferenceData(filterData);
            setLoading(false);
        } catch (e: any) {
            if (e.response?.status) setErrorCode(e.response?.status);
            else setErrorCode(error.DEFAULT);
        } finally {
            setLoading(false);
        }
    };

    const setSearchState = (val: boolean) => {
        setDefaultSearchState(val);
    }

    return (
        <FilterContext.Provider
          value={{
            defaultSearchState,
            filterPreferenceData,
            loading,
            getFilterPreferenceData,
            saveFilterPreferenceData,
            setSearchState
          }}>
          {props.children}
        </FilterContext.Provider>
      );
}

export const useFilterPreference = () => {
    return useContext(FilterContext);
};